// src/data/menu.ts

export interface MenuItem {
  title: string
  icon?: string
  to?: string
  children?: MenuItem[]
  componentName?: string
}

// export const menu: MenuItem[] = [
//   {
//     title: 'Dashboard',
//     icon: 'mdi-view-dashboard',
//     to: '/dashboard',
//   },
//   {
//     title: 'Secciones',
//     icon: 'mdi-view-list',
//     to: '/secciones',
//     children: [
//       // { title: 'Todos', to: '/secciones', icon: 'mdi-account-group' },
//       // { title: 'Nosotros', to: '/nosotros', icon: 'mdi-account-group' },
//       // { title: 'Servicios', to: '/servicios', icon: 'mdi-account-group' },
//       { title: 'Testimonios', to: '/testimonios', icon: 'mdi-account-group' },
//       { title: 'Galería', to: '/gallery', icon: 'mdi-account-group' },
//       // { title: 'Contacto', to: '/contacto', icon: 'mdi-account-group' },
//     ],
//   },
//   {
//     title: 'Usuarios',
//     icon: 'mdi-account-group',
//     children: [
//       { title: 'Lista de Usuarios', to: '/users' },
//       // { title: 'Roles', to: '/roles' },
//     ],
//   },
//   {
//     title: 'Servicios',
//     icon: 'mdi-wrench',
//     children: [
//       { title: 'Lista de Servicios', to: '/servicios' }
//     ],
//   },
//   {
//     title: 'Cotizaciones',
//     icon: 'mdi-cash-register',
//     children: [
//       { title: 'Nueva cotización', to: '/cotizaciones/new' },
//       { title: 'Historial de cotizaciones', to: '/cotizaciones/list' },
//       { title: 'Cotizaciones con opciones', to: '/cotizaciones/opciones' }
//     ],
//   },
//   // {
//   //   title: 'Configuración',
//   //   icon: 'mdi-cog',
//   //   children: [
//   //     { title: 'General', to: '/settings/general' },
//   //     { title: 'Seguridad', to: '/settings/security' },
//   //   ],
//   // },
// ]

// data/menu.ts
export const menu: MenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'mdi-view-dashboard',
    to: '/dashboard',
    componentName: 'DashboardView' // Debe coincidir con el nombre del componente
  },
  {
    title: 'Secciones',
    icon: 'mdi-view-list',
    to: '/secciones',
    children: [
      { title: 'Testimonios', to: '/testimonios', icon: 'mdi-account-group', componentName: 'testimoniosView' },
      { title: 'Galería', to: '/gallery', icon: 'mdi-account-group', componentName: 'galleryView' },
    ],
  },
  {
    title: 'Usuarios',
    icon: 'mdi-account-group',
    children: [
      { title: 'Lista de Usuarios', to: '/users', componentName: 'UsersView' },
      // { title: 'Roles', to: '/roles' },
    ],
  },
  {
    title: 'Servicios',
    icon: 'mdi-wrench',
    children: [
      { title: 'Lista de Servicios', to: '/servicios', componentName: 'services.view' }
    ],
  },
  {
    title: 'Cotizaciones',
    icon: 'mdi-cash-register',
    children: [
      { title: 'Nueva cotización', to: '/cotizaciones/new', componentName: 'cotizacionNew' },
      { title: 'Historial de cotizaciones', to: '/cotizaciones/list', componentName: 'cotizacionList' },
      { title: 'Cotizaciones con opciones', to: '/cotizaciones/opciones', componentName: 'cotizacionOpciones' }
    ],
  },
]